import { Box } from '@mui/material';

/**
 * A plan error as text, or as a real list when it names several steps.
 *
 * `describePlanError` joins every failing step as "• step: message" lines under a
 * one-line heading (the API reports them all). One line stays a sentence; several
 * become a list a screen reader announces as one.
 */
export default function PlanErrorText({ text }: { text: string }) {
  const lines = text.split('\n');
  if (lines.length < 2) return <>{text}</>;
  const [heading, ...items] = lines;
  return (
    <>
      {heading}
      <Box component="ul" sx={{ m: 0, mt: 0.5, pl: 2.5 }}>
        {items.map((line, index) => <li key={`${index}:${line}`}>{line.replace(/^•\s*/, '')}</li>)}
      </Box>
    </>
  );
}
